import { LandingPage } from "@client/components/auth";
import { authClient } from "@client/lib/auth-client";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

// Better Auth's OAuth callback redirects failures back here with a
// machine-readable `?error=` code (e.g. `account_not_linked`).
const landingSearchSchema = z.object({
	error: z.string().optional(),
	error_description: z.string().optional(),
});

export const Route = createFileRoute("/")({
	validateSearch: landingSearchSchema,
	beforeLoad: async () => {
		const session = await authClient.getSession();
		// Check if session exists and has data with user
		if (session?.data?.user) {
			throw redirect({
				to: "/dashboard",
			});
		}
	},
	component: LandingPage,
});
